<template>
    <v-app>
        {{ count }}
    </v-app>
</template>

<script>
    const fb = require('../firebase')

    export default {
        name: "DataOut",
        data() {
            return {
                group: {},
                groups: [],
                devices: [],
                transactions: {},
                settings: [],
                txns: [],
                mac_start_keys: [],
                users: [],
                count: 0,
                activity: [],
                orders: [],
                tokens: [],
                statuses: []
            }
        },
        mounted() {
          //this.fetchGroup()
            this.fetchData()
        },
        methods: {
            inc: function () {
                this.count = this.count + 1
            },
            fetchData: async function () {
                this.inc()
                await fb.groupsCollection
                    .get()
                    .then((collection) => {
                        if (!collection.empty) {
                            collection.forEach((record) => {
                                let data = record.data()
                                data['id'] = record.id
                                this.groups.push(data)
                            })
                        }
                    })

                this.inc()
                await fb.usersCollection
                    .get()
                    .then((collection) => {
                        if (!collection.empty) {
                            collection.forEach((record) => {
                                let data = record.data()
                                data['id'] = record.id
                                this.users.push(data)
                            })
                        }
                    })

                this.inc()
                await fb.settingsCollection
                    .get()
                    .then((collection) => {
                        if (!collection.empty) {
                            collection.forEach((record) => {
                                let data = record.data()
                                data['id'] = record.id
                                this.settings.push(data)
                            })
                        }
                    })

                this.inc()
                await fb.formsCollection
                    .get()
                    .then((collection) => {
                        if (!collection.empty) {
                            collection.forEach((record) => {
                                let data = record.data()
                                data['id'] = record.id
                                this.orders.push(data)
                            })
                        }
                    })

                this.inc()
                await fb.tokensCollection
                    .get()
                    .then((collection) => {
                        if (!collection.empty) {
                            collection.forEach((record) => {
                                let data = record.data()
                                data['id'] = record.id
                                this.tokens.push(data)
                            })
                        }
                    })

                this.inc()
                await fb.transactionsCollection
                    .limit(1000)
                    .get()
                    .then((collection) => {
                        if (!collection.empty) {
                            collection.forEach((record) => {
                                let data = record.data()
                                data['id'] = record.id
                                this.txns.push(data)
                            })
                        }
                    })

                this.inc()
                await fb.statusesCollection
                    .limit(1000)
                    .get()
                    .then((collection) => {
                        if (!collection.empty) {
                            collection.forEach((record) => {
                                let data = record.data()
                                data['id'] = record.id
                                this.statuses.push(data)
                            })
                        }
                    })

                /*
                                this.inc()
                                await fb.macStartKeysCollection
                                    .get()
                                    .then((collection) => {
                                        if (!collection.empty) {
                                            collection.forEach((record) => {
                                                let data = record.data()
                                                data['id'] = record.id
                                                this.mac_start_keys.push(data)
                                            })
                                        }
                                    })

                                this.inc()
                                await fb.logCollection
                                    .get()
                                    .then((collection) => {
                                        if (!collection.empty) {
                                            collection.forEach((record) => {
                                                let data = record.data()
                                                data['id'] = record.id
                                                this.activity.push(data)
                                            })
                                        }
                                    })
                */
                this.inc()
            },
            fetchGroup: async function () {
                let groupId = this.$route.params.group_id

                if (groupId !== undefined) {
                    await fb.groupsCollection
                        .doc(groupId)
                        .get()
                        .then((group) => {
                            this.group = group.data()
                            this.devices = this.group.devices
                        })

                    this.devices.forEach((device) => {

                        let device_id = 'castles_' + device + '@kineticsmart.com'

                        let start = new Date('2019-07-15')

                        fb.transactionsCollection
                            .where('deviceId', '==', device_id)
                            .where('timestamp', '>', start)
                            .get()
                            .then((transactions) => {

                                if (!transactions.empty) {
                                    transactions.forEach((transaction) => {
                                        let this_transaction = transaction.data()
                                        this_transaction['merchant_receipt'] = ''
                                        this_transaction['customer_receipt'] = ''

                                        if (this_transaction['terminal_id'] !== '33420008' && 'merchant_id' !== '010003382') {
                                            this.transactions[this_transaction['uuid']] = this_transaction
                                            this.txns.push(this_transaction)
                                            //console.log(this_transaction)
                                        }
                                        // this.transactions.push(this_transaction)
                                    })
                                }
                            })
                    })
                }

            }
        }
    }
</script>

<style scoped>

</style>
